import { ResponsiveMetric } from '../../constants/media';

import type { LayoutPreferenceType, PanelPreferencePosition } from '@kc-console/context';

const MIN_HEIGHT = 600;
// 목록 우측 패널의 최소 폭이며 상세 우측 패널의 임계값과는 다르다.
const MIN_WIDTH = ResponsiveMetric.EXTRA_SMALL_MAX;

export interface ComputePanelAvailabilityParams {
  innerHeight: number;
  innerWidth: number;
  layoutType: LayoutPreferenceType;
  position: PanelPreferencePosition;
}

/**
 * 패널 위치와 레이아웃 유형에 따른 사용 가능 여부를 계산
 */
export function computePanelAvailability({
  layoutType,
  position,
  innerWidth,
  innerHeight,
}: ComputePanelAvailabilityParams): boolean {
  if (layoutType === 'detail' && position === 'right') {
    // 본문과 우측 패널을 동시에 사용하기 위한 최소 뷰포트
    return innerWidth >= ResponsiveMetric.MEDIUM_MIN;
  }

  if (layoutType === 'list' && position === 'bottom') {
    // 본문과 하단 패널을 동시에 사용하기 위한 최소 뷰포트
    return innerHeight >= MIN_HEIGHT;
  }

  return position === 'bottom' ? innerHeight >= MIN_HEIGHT : innerWidth >= MIN_WIDTH;
}
